import { Localized } from 'dg-web-shared/lib/Localization.tsx';
import {
    ConfirmationDialog,
    ConfirmationDialogVersions,
} from './ConfirmationDialog.tsx';

export function OtpActivationNotPossibleWarning({
    open,
    onConfirm,
}: {
    open: boolean;
    onConfirm: () => void;
}) {
    return (
        <ConfirmationDialog
            open={open}
            title={
                <Localized
                    de="Aktivierung nicht möglich"
                    fr="Activation pas possible"
                    it="Attivazione non possibile"
                    en="Activation not possible"
                />
            }
            onConfirm={onConfirm}
            confirmLabel={<Localized de="OK" fr="OK" it="OK" en="OK" />}
            dialogVersion={ConfirmationDialogVersions.ERROR}
        >
            <p>
                <Localized
                    de="Die Zwei-Faktor-Authentifizierung (2FA) kann nur vom Benutzer selbst aktiviert werden."
                    fr="L'authentification à deux facteurs (2FA) ne peut être activée que par l'utilisateur lui-même."
                    it="L'autenticazione a due fattori (2FA) può essere attivata solo dall'utente stesso."
                    en="Two-factor authentication (2FA) may only be activated by the user themselves."
                />
            </p>
        </ConfirmationDialog>
    );
}
